import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import moment from 'moment';

const CONTEXT = 'cms';

const getUrl = (secondHandApproval) => {
  if (secondHandApproval) return DepsService.rest.cms['login-popup'].second.url;
  return DepsService.rest.cms['login-popup'].first.url;
};

export const fetchPopup = async (secondHandApproval, jurisdictionId) => {
  const url = getUrl(secondHandApproval);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

const getDateTime = (date, time) =>
  moment(date * 1)
    .utc()
    .hour(moment(time, 'HH:mm').get('hour'))
    .minute(moment(time, 'HH:mm').get('minute'));

export const fetchPopupOnLogin = async (jurisdictionId, session) => {
  const { entries, properties } = await fetchPopup(false, jurisdictionId);
  const [popup] = entries;

  const popupFields = appHelpers.getFieldsFromEntry(popup);

  if (popup.createdBy === session.emailAddress) {
    return '';
  }
  if (popupFields && properties && properties.type === 'enabled') {
    return popupFields[session.locale].content;
  }
  if (popupFields && properties && properties.type === 'range') {
    const now = moment.unix(session.lotteryTime).utc();
    const dateFrom = getDateTime(properties.dateFrom, properties.timeFrom);
    const dateTo = getDateTime(properties.dateTo, properties.timeTo);

    if (now.isBetween(dateFrom, dateTo, 'minute', '[]')) {
      return popupFields[session.locale].content;
    }
  }
  return '';
};

export const publishPopup = async (secondHandApproval, jurisdictionId, entries, properties) => {
  const url = getUrl(secondHandApproval);
  const queryParams = { entries, properties };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const discardPopup = async (jurisdictionId) => {
  const { url } = DepsService.rest.cms['login-popup'].discard;
  const queryParams = {};
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/login-popup.api.js